var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"depositCertificateBox"},[_vm._m(0),_c('div',{staticClass:"echart",style:(_vm.myChartStyle),attrs:{"id":"mychart"}})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"depositCertificate"},[_c('p',[_vm._v("存证量")]),_c('div',{staticClass:"today"},[_c('p',[_vm._v("今日存证:")]),_c('span',[_vm._v("15")])])])
}]

export { render, staticRenderFns }